import { ReactNode } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IRoute } from 'core/components/layout/Routing';
import { PathBankStatements, PathsDocuments } from 'const';

export type StateLocationType = {
  pathDocuments?: PathsDocuments;
  pathBankStatements?: PathBankStatements;
};
export type RouteAppComponentProps = RouteComponentProps<{}, {}, StateLocationType>;

export interface AppRouteType extends Omit<IRoute<RouteAppComponentProps>, 'render'> {
  render?: ((props: any) => ReactNode) | undefined;
}

export type IErrors<T> = {
  [K in keyof T]?: string;
};

export type SelectOptionType = {
  value: string | number;
  label: string;
};

export type IMenuItem = {
  path: string;
  label: string;
};

export interface IRequestBase {
  onSuccess?: <T>(data?: T) => void;
  onFailed?: <T>(data?: T) => void;
  onFinally?: () => void;
}

export interface IViolation {
  code: string | null;
  message: string;
  propertyPath: string;
}

export enum EmploymentTypes {
  SALARIED = 'salaried',
  SELF_EMPLOYED = 'self employed',
  GOVERNMENT_EMPLOYEE = 'government employee',
  POLICE_MILITARY = 'police / military',
  LEGAL_SERVICES = 'legal services',
  UNEMPLOYED = 'unemployed',
}

export enum MainSourceOfIncomeTypes {
  PART_TIME_JOB = 'part-time job',
  HELP_OF_RELATIVES = 'help of relatives',
  SOCIAL_PAYMENTS = 'social payments',
  NO_INCOME = 'no income',
}

export enum DomainTypes {
  GMAIL = '@gmail.com',
  YAHOO = '@yahoo.com',
  OTHER = 'other',
}

export enum TypePayments {
  DUE_AMOUNT = 'Due amount',
  PAYMENT_FOR_TODAY = 'Next payment',
  FULL_REPAYMENT = 'Full repayment',
  OTHER_AMOUNT = 'Other amount',
}

export interface PaymentType {
  label: TypePayments;
  value: TypePayments;
}

export interface ListTypesPaymentsData {
  [key: number]: PaymentType[];
}

export enum VerificationDocumentTypes {
  DRIVING_LICENCE = 'driver_license',
  VOTER_ID = 'voter_id',
  PAN_CARD = 'pan_card',
  AADHAAR_NUMBER = 'aadhaar_number',
}

export enum DocumentsType {
  Pancard = 'pancard',
  SelfieAndPancard = 'selfie_and_pancard',
  AadharCard = 'aadharcard',
  SelfieAndAadharCard = 'selfie_and_aadharcard',
}

export enum DictionaryTypes {
  Education = 'education',
  Marital_status = 'marital_status',
  Loan_purpose = 'loan_purpose',
}

export enum SelfieType {
  PHOTO = 'photo',
  OZ_FORENSICS = 'oz_forensics_liveness',
  SKIP = 'skip',
}

export interface IOnboardingType {
  selfie: SelfieType;
}
